import req from '@sportninja/common/api/request'
import { useCallback, useState } from 'react'
import { RegistrationTypes } from '../types/Registration'
// @ts-ignore
import { store } from '../store'

interface TypeObject {
  [key: string]: []
}

/**
 * extractValues: Helper function to transform types API response
 * Extracts values from the types API response and creates a RegistrationTypes object
 */
function extractValues(data: TypeObject[]): RegistrationTypes {
  const extracted: any = {}
  data.forEach((item) => {
    const key = Object.keys(item)[0]
    const mappedKey = key.replace('_type', '')
    extracted[mappedKey] = item[key]
  })
  return extracted as RegistrationTypes
}

/**
 * useRegistrationTypes: Hook to fetch registration types
 * Reads from Redux store (populated on app init) with API fallback
 */
export const useRegistrationTypes = () => {
  const [types, setTypes] = useState<RegistrationTypes | null>(null)
  const [error, setError] = useState<Error | null>(null)

  const fetchTypes = useCallback(async () => {
    try {
      setError(null)
      // Read from Redux store (populated on app init) instead of calling API
      const reduxTypes = store?.getState()?.types?.registrationTypes

      if (reduxTypes && Object.keys(reduxTypes).length > 0) {
        setTypes(reduxTypes as RegistrationTypes)
        return
      }
      // Fallback to direct API call if Redux state is not yet populated
      const raw = await req('/types/registration')
      const extractedTypes = extractValues(raw)
      setTypes(extractedTypes)
    } catch (err) {
      setError(
        err instanceof Error
          ? err
          : new Error('An error occurred while fetching types')
      )
      throw err instanceof Error
        ? err
        : new Error('An error occurred while fetching types')
    }
  }, [])

  return { types, fetchTypes, error }
}
